.chip {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-400);
  border-radius: 1rem;
  cursor: pointer;
  display: grid;
  font-family: inherit;
  grid-template-columns: auto 1fr;
  min-height: 2rem;
  padding: 0 0 0 1rem;
  user-select: none;
  width: fit-content;
}

.chip:hover {
  background-color: var(--color-grey-400);
}

.chip:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.chip__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.chip__close-button {
  margin: 0 0.5rem;
}
